var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable prettier/prettier */
import React, { useCallback } from 'react';
import { List, Tabs as AntTabs } from 'antd';
import throttle from 'lodash/throttle';
import lodashTrim from 'lodash/trim';
import { LoadingOutlined } from '@ant-design/icons';
import ListItem, { DefaultAvatarSize } from '../ListItem';
import { SearchType, } from '../UserSelection/';
import getHighlightComp from '../utils';
import ListEmptyPlaceholder from '../ListEmptyPlaceholder';
import { LoadMore } from '../List';
import { ContactsTag, GroupTag } from '../Tags';
import isNull from 'lodash/isNull';
import searchIcon from '../images/app_ic_search.png';
var loadingIcon = React.createElement(LoadingOutlined, { style: { fontSize: 24 }, spin: true });
var TabPane = AntTabs.TabPane;
var SearchListItem = function (props) {
    var _a = React.useContext(SearchGlobalContext), onGetAvatarURL = _a.onGetAvatarURL, authData = _a.authData, activeKey = _a.activeKey;
    var data = props.data, onClick = props.onClick, t = props.t, rest = __rest(props, ["data", "onClick", "t"]);
    var avatar = data.avatar;
    var origin = data.origin;
    var itemTag = null;
    if (activeKey === SearchType.All ||
        activeKey === SearchType.Contacts ||
        activeKey === SearchType.Group) {
        if (origin.userId === data.id) {
            // 联系人
            var userI = { teamId: origin.teamId, app: origin.app };
            var userII = { teamId: authData.selectedTeamId, app: authData.ddAppId };
            itemTag = React.createElement(ContactsTag, { userI: userI, userII: userII, t: t });
        }
        else if ((origin.gid || origin.groupId) === data.id) {
            // 群组
            itemTag = React.createElement(GroupTag, { kind: origin.kind, subKind: origin.subKind, t: t });
        }
    }
    return (React.createElement(ListItem, __assign({ style: {
            paddingLeft: 24,
        }, data: __assign(__assign({}, data), (onGetAvatarURL && typeof avatar === 'string'
            ? {
                avatar: onGetAvatarURL(avatar, DefaultAvatarSize, DefaultAvatarSize),
            }
            : {})), onClick: function () {
            if (onClick) {
                onClick(data);
            }
        }, tag: itemTag }, rest)));
};
var SearchGlobalContext = React.createContext({
    t: function () { },
    onSearchGlobal: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ({})];
    }); }); },
    keyword: '',
    activeKey: SearchType.All,
    authData: null,
});
var tabsData = [
    { key: SearchType.All },
    { key: SearchType.Contacts },
    { key: SearchType.Group },
    { key: SearchType.JoySpace },
    { key: SearchType.App },
    { key: SearchType.MessageHistory },
];
function GroupTitle(_a) {
    var title = _a.title;
    return (React.createElement("h4", { className: "color-gray", style: {
            fontSize: 14,
            fontWeight: 'normal',
            margin: 0,
            padding: '0 24px',
            lineHeight: '40px',
            position: 'relative',
        } },
        title,
        React.createElement("span", { className: "split-line-bg", style: {
                position: 'absolute',
                height: 1,
                bottom: 0,
                right: 0,
                left: 24,
            } })));
}
function filterAppInfo(apps) {
    return (apps || []).map(function (item) {
        var appId = item.appId, appName = item.appName, avatar = item.avatar, highlight = item.highlight;
        return {
            id: appId,
            name: getHighlightComp(highlight, 'appName', appName),
            avatar: avatar,
            origin: item,
        };
    });
}
function getJoySpaceDocIconByPageType(title, pageType, type) {
    return "https://apijoyspace.jdcloud.com/v1/common/icons?title=" + title + "&pageType=" + pageType + "&type=" + type + "&client=web";
}
function filterJoySpaceInfo(pages) {
    return (pages || []).map(function (item) {
        var id = item.id, title = item.title, pageType = item.pageType, highlight = item.highlight, type = item.type;
        return {
            id: id,
            name: getHighlightComp(highlight, 'title', title),
            avatar: getJoySpaceDocIconByPageType(title, pageType, type),
            origin: item,
        };
    });
}
function filterContactInfo(contacts) {
    return (contacts || []).map(function (item) {
        var userId = item.userId, realName = item.realName, avatar = item.avatar, highlight = item.highlight;
        return {
            id: userId,
            name: getHighlightComp(highlight, 'realName', realName),
            avatar: avatar,
            displayName: realName,
            origin: item,
            desc: item.deptName,
        };
    });
}
function filterGroupInfo(groups) {
    return (groups || []).map(function (item) {
        var groupId = item.groupId, groupName = item.groupName, avatar = item.avatar, highlight = item.highlight;
        return {
            id: groupId,
            name: getHighlightComp(highlight, 'groupName', groupName),
            displayName: groupName,
            avatar: avatar,
            origin: item,
        };
    });
}
function DetailSearchBtn(_a) {
    var text = _a.text, onClick = _a.onClick;
    return (React.createElement("div", { className: "flex-layout-center-left", style: {
            lineHeight: '40px',
            padding: '0 24px',
        } },
        React.createElement("div", { className: "color-primary", style: {
                fontSize: 14,
                cursor: 'pointer',
            }, onClick: onClick },
            React.createElement("img", { src: searchIcon, alt: "", width: "12px" }),
            "\u00A0",
            text)));
}
function DataList(_a) {
    var _this = this;
    var onClick = _a.onClick, searchType = _a.searchType;
    var _b = React.useContext(SearchGlobalContext), onSearchGlobal = _b.onSearchGlobal, keyword = _b.keyword, activeKey = _b.activeKey, t = _b.t;
    var _c = React.useState(null), error = _c[0], setError = _c[1];
    var _d = React.useState(null), result = _d[0], setResult = _d[1];
    var _e = React.useState(false), loading = _e[0], setLoading = _e[1];
    var _f = React.useState(false), hasMore = _f[0], setHasMore = _f[1];
    var keywordRef = React.useRef();
    keywordRef.current = keyword;
    var activeKeyRef = React.useRef();
    activeKeyRef.current = activeKey;
    var pageSizeRef = React.useRef(10);
    var pageNoRef = React.useRef(1);
    var doSearch = function (pageNo) { return __awaiter(_this, void 0, void 0, function () {
        var res, apps, contacts, groups, pages, data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (activeKeyRef.current !== searchType) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, onSearchGlobal({
                            keyword: keywordRef.current,
                            searchType: searchType,
                            pageNo: pageNo,
                            pageSize: pageSizeRef.current,
                        })];
                case 2:
                    res = _a.sent();
                    apps = res.apps, contacts = res.contacts, groups = res.groups, pages = res.pages;
                    data = [];
                    switch (searchType) {
                        case SearchType.Contacts: {
                            data = filterContactInfo(contacts);
                            break;
                        }
                        case SearchType.Group: {
                            data = filterGroupInfo(groups);
                            break;
                        }
                        case SearchType.JoySpace: {
                            data = filterJoySpaceInfo(pages);
                            break;
                        }
                        case SearchType.App: {
                            data = filterAppInfo(apps);
                            break;
                        }
                        default:
                    }
                    if (pageNo === 1) {
                        setResult(data || []);
                    }
                    else {
                        setResult(__spreadArrays((result || []), data));
                    }
                    setHasMore((data || []).length >= pageSizeRef.current);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    setResult([]);
                    setHasMore(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var doSearchThrottle = React.useRef(throttle(doSearch, 500)).current;
    React.useEffect(function () {
        if (!lodashTrim(keywordRef.current)) {
            setResult(null);
            return;
        }
        doSearchThrottle(1);
    }, [keyword, activeKey, doSearchThrottle]);
    var getLoadingProp = useCallback(function (list) {
        return {
            delay: 10,
            indicator: loadingIcon,
            spinning: isNull(list),
            wrapperClassName: 'loading-wrapper',
        };
    }, []);
    var loadMore = null;
    // if (loading) {
    //     loadMore = (
    //         <LoadMore>
    //             <Loading size={14} />
    //         </LoadMore>
    //     );
    //     if (pageNoRef.current === 1) {
    //         return loadMore;
    //     }
    // }else
    if (hasMore) {
        loadMore = (React.createElement(LoadMore, { onClick: function () {
                pageNoRef.current = pageNoRef.current + 1;
                doSearch(pageNoRef.current);
            } }, t('list.loadMore')));
    }
    else if (result && result.length) {
        loadMore = React.createElement(LoadMore, null, t('list.noMore'));
    }
    return (React.createElement(List, { loading: getLoadingProp(result), dataSource: result || [], loadMore: loadMore, 
        // fetchData={async (params) => doSearchThrottle(keyword, activeKey, params)}
        renderItem: function (item) { return (React.createElement(SearchListItem, { style: {
                paddingLeft: 24,
            }, data: item, onClick: function () {
                if (onClick) {
                    onClick(item);
                }
            }, t: t })); } }));
}
function TabPaneAll(_a) {
    var _this = this;
    var 
    // data,
    t = _a.t, onClick = _a.onClick;
    // const { contacts: oContacts, groups: oGroups } = data || {};
    // const contacts = Array.isArray(oContacts) ? oContacts : [];
    // const groups = Array.isArray(oGroups) ? oGroups : [];
    var _b = React.useContext(SearchGlobalContext), onSearchGlobal = _b.onSearchGlobal, keyword = _b.keyword, setTabIndex = _b.setTabIndex, activeKey = _b.activeKey;
    var _c = React.useState(null), result = _c[0], setResult = _c[1];
    var _d = React.useState(false), loading = _d[0], setLoading = _d[1];
    var keywordRef = React.useRef();
    keywordRef.current = keyword;
    var activeKeyRef = React.useRef();
    activeKeyRef.current = activeKey;
    var doSearch = function () { return __awaiter(_this, void 0, void 0, function () {
        var res, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (activeKeyRef.current !== SearchType.All) {
                        return [2 /*return*/];
                    }
                    if (!keywordRef.current) {
                        return [2 /*return*/, []];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setLoading(true);
                    return [4 /*yield*/, onSearchGlobal({
                            keyword: keywordRef.current,
                            searchType: SearchType.All,
                            pageNo: 1,
                            pageSize: 3,
                        })];
                case 2:
                    res = _a.sent();
                    setResult(res);
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    setResult({});
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var doSearchThrottle = React.useRef(throttle(doSearch, 500)).current;
    React.useEffect(function () {
        if (!lodashTrim(keywordRef.current)) {
            setResult(null);
            return;
        }
        doSearchThrottle();
    }, [keyword, doSearchThrottle, activeKey]);
    if (!result) {
        return React.createElement(ListEmptyPlaceholder, { placeholder: t('search.emptyPl') });
    }
    var contacts = result.contacts, groups = result.groups, apps = result.apps, pages = result.pages;
    var contactsData = filterContactInfo(contacts || []);
    var contactComp = contactsData.length ? (React.createElement("div", null,
        React.createElement(GroupTitle, { title: t("search.tabs." + SearchType.Contacts) }),
        React.createElement(List, { loading: loading && {
                indicator: React.createElement(LoadingOutlined, { size: 16 }),
            }, dataSource: contactsData, renderItem: function (item) { return (React.createElement(SearchListItem, { data: item, onClick: function () {
                    if (onClick) {
                        onClick(SearchType.Contacts, item);
                    }
                }, t: t })); } }),
        contactsData.length > 0 ? (React.createElement(DetailSearchBtn, { text: t('search.moreContacts'), onClick: function () {
                setTabIndex(SearchType.Contacts);
            } })) : null)) : null;
    var groupsData = filterGroupInfo(groups);
    var groupsComp = groupsData.length ? (React.createElement("div", null,
        React.createElement(GroupTitle, { title: t("search.tabs." + SearchType.Group) }),
        React.createElement(List, { loading: loading && {
                indicator: React.createElement(LoadingOutlined, { size: 16 }),
            }, dataSource: groupsData, renderItem: function (item) { return (React.createElement(SearchListItem, { style: {
                    paddingLeft: 24,
                }, data: item, onClick: function () {
                    if (onClick) {
                        onClick(SearchType.Group, item);
                    }
                }, t: t })); } }),
        groupsData.length > 0 ? (React.createElement(DetailSearchBtn, { text: t('search.moreGroups'), onClick: function () {
                setTabIndex(SearchType.Group);
            } })) : null)) : null;
    var appsData = filterAppInfo(apps);
    var appsComp = appsData.length ? (React.createElement("div", null,
        React.createElement(GroupTitle, { title: t("search.tabs." + SearchType.App) }),
        React.createElement(List, { loading: loading && {
                indicator: React.createElement(LoadingOutlined, { size: 16 }),
            }, dataSource: appsData, renderItem: function (item) { return (React.createElement(SearchListItem, { style: {
                    paddingLeft: 24,
                }, data: item, onClick: function () {
                    if (onClick) {
                        onClick(SearchType.App, item);
                    }
                }, t: t })); } }),
        appsData.length > 0 ? (React.createElement(DetailSearchBtn, { text: t('search.moreApps'), onClick: function () {
                setTabIndex(SearchType.App);
            } })) : null)) : null;
    var pagesData = filterJoySpaceInfo(pages);
    var pagesComp = pagesData.length ? (React.createElement("div", null,
        React.createElement(GroupTitle, { title: t("search.tabs." + SearchType.JoySpace) }),
        React.createElement(List, { loading: loading && {
                indicator: React.createElement(LoadingOutlined, { size: 16 }),
            }, dataSource: pagesData, renderItem: function (item) { return (React.createElement(SearchListItem, { style: {
                    paddingLeft: 24,
                }, data: item, onClick: function () {
                    if (onClick) {
                        onClick(SearchType.JoySpace, item);
                    }
                }, t: t })); } }),
        pagesData.length > 0 ? (React.createElement(DetailSearchBtn, { text: t('search.moreJoySpaces'), onClick: function () {
                setTabIndex(SearchType.JoySpace);
            } })) : null)) : null;
    return (React.createElement("div", null,
        contactComp,
        groupsComp,
        appsComp,
        pagesComp));
}
function TabPaneLianxiren(_a) {
    var 
    // data,
    t = _a.t, onClick = _a.onClick;
    var keyword = React.useContext(SearchGlobalContext).keyword;
    if (!lodashTrim(keyword)) {
        return React.createElement(ListEmptyPlaceholder, { placeholder: t('search.emptyPl') });
    }
    // const { contacts = [] } = data || {};
    // if (!Array.isArray(contacts) || !contacts.length) {
    //     return <ListEmptyPlaceholder placeholder={t('search.emptyPl')} />;
    // }
    // const contactsData = filterContactInfo(contacts);
    return (React.createElement(DataList, { searchType: SearchType.Contacts, onClick: function (data) {
            if (onClick) {
                onClick(SearchType.Contacts, data);
            }
        } }));
}
function TabPaneQunzu(_a) {
    var 
    // data,
    t = _a.t, onClick = _a.onClick;
    var keyword = React.useContext(SearchGlobalContext).keyword;
    if (!lodashTrim(keyword)) {
        return React.createElement(ListEmptyPlaceholder, { placeholder: t('search.emptyPl') });
    }
    // const { groups = [] } = data || {};
    // if (!Array.isArray(groups) || !groups.length) {
    //     return <ListEmptyPlaceholder placeholder={t('search.emptyPl')} />;
    // }
    // const groupsData = filterGroupInfo(groups);
    return (React.createElement(DataList, { searchType: SearchType.Group, onClick: function (data) {
            if (onClick) {
                onClick(SearchType.Group, data);
            }
        } }));
}
function TabPaneYingyong(_a) {
    var onClick = _a.onClick;
    var _b = React.useContext(SearchGlobalContext), keyword = _b.keyword, t = _b.t;
    if (!lodashTrim(keyword)) {
        return React.createElement(ListEmptyPlaceholder, { placeholder: t('search.emptyPl') });
    }
    return (React.createElement(DataList, { searchType: SearchType.App, onClick: function (data) {
            if (onClick) {
                onClick(SearchType.App, data);
            }
        } }));
}
function TabPaneLiaotianjilu(_a) {
    var onClick = _a.onClick;
    var _b = React.useContext(SearchGlobalContext), keyword = _b.keyword, t = _b.t;
    if (!lodashTrim(keyword)) {
        return React.createElement(ListEmptyPlaceholder, { placeholder: t('search.emptyPl') });
    }
    return (React.createElement(DataList, { searchType: SearchType.MessageHistory, onClick: function (data) {
            if (onClick) {
                onClick(SearchType.MessageHistory, data);
            }
        } }));
}
function TabPaneJoySpace(_a) {
    var onClick = _a.onClick;
    var _b = React.useContext(SearchGlobalContext), keyword = _b.keyword, t = _b.t;
    if (!lodashTrim(keyword)) {
        return React.createElement(ListEmptyPlaceholder, { placeholder: t('search.emptyPl') });
    }
    return (React.createElement(DataList, { searchType: SearchType.JoySpace, onClick: function (data) {
            if (onClick) {
                onClick(SearchType.JoySpace, data);
            }
        } }));
}
// eslint-disable-next-line
function getTabPane(item, t, onClick) {
    switch (item.key) {
        case SearchType.All:
            return React.createElement(TabPaneAll, { t: t, onClick: onClick });
        case SearchType.Contacts:
            return React.createElement(TabPaneLianxiren, { t: t, onClick: onClick });
        case SearchType.Group:
            return React.createElement(TabPaneQunzu, { t: t, onClick: onClick });
        case SearchType.JoySpace:
            return React.createElement(TabPaneJoySpace, { onClick: onClick });
        case SearchType.App:
            return React.createElement(TabPaneYingyong, { onClick: onClick });
        case SearchType.MessageHistory:
            return React.createElement(TabPaneLiaotianjilu, { onClick: onClick });
        default:
            return null;
    }
}
export default function Tabs(_a) {
    var config = _a.config, 
    // resultAll,
    activeKey = _a.activeKey, onActiveKeyChange = _a.onActiveKeyChange, onItemClick = _a.onItemClick, onGetAvatarURL = _a.onGetAvatarURL, onSearchGlobal = _a.onSearchGlobal, keyword = _a.keyword, t = _a.t, authData = _a.authData;
    var data = config;
    if (!data) {
        data = tabsData;
    }
    return (React.createElement(SearchGlobalContext.Provider, { value: {
            t: t,
            onGetAvatarURL: onGetAvatarURL,
            onSearchGlobal: onSearchGlobal,
            keyword: keyword,
            activeKey: activeKey,
            setTabIndex: onActiveKeyChange,
            authData: authData,
        } },
        React.createElement(AntTabs, { size: "small", className: "searchModalTabs", style: {
                flex: 1,
            }, activeKey: activeKey, onChange: function (key) {
                onActiveKeyChange(key);
            } }, data.map(function (item) { return (React.createElement(TabPane, { key: item.key, tab: t("search.tabs." + item.key) }, getTabPane(item, t, onItemClick))); }))));
}
/*
<ConfigProvider renderEmpty={() => <Empty t={t} />}>

            </ConfigProvider>
*/
//# sourceMappingURL=Tabs.js.map